import { ButtonProps } from "antd/lib/button";
import { Dispatch, SetStateAction, useEffect, useState, createRef } from "react";
import { EditIcon, PlusIcon } from "../icons";
import { generalTexts } from "texts/generalTexts";

type Props = {
  name: string;
  previewImageUrl?: string | ArrayBuffer;
  setPreviewImageUrl?: Dispatch<SetStateAction<any>>;
  defaultImage?: string;
  inputClassName?: string;
  inputWrapperClassName?: string;
  addButtonProps?: ButtonProps;
  changeButtonProps?: ButtonProps;
  removeButtonProps?: ButtonProps;
  disabled?: boolean;
  required?: boolean;
  title: string;
  className?: string;
  validationError?: boolean;
};

function ImageUpload({ name, validationError = false, required = false, className = "", previewImageUrl, setPreviewImageUrl, inputClassName, inputWrapperClassName, disabled = false, title = "" }: Props) {
  const [fileState, setFile] = useState(null);
  const [imageUrlState, setImageUrlState] = useState(null);

  let fileInput = createRef<HTMLInputElement>();

  useEffect(() => {
    previewImageUrl ? setImageUrlState(previewImageUrl) : setImageUrlState(null);
  }, [previewImageUrl]);

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setFile(file);
      setImageUrlState(reader.result);
    };
    setPreviewImageUrl((prev) => ({
      ...prev,
      [name]: file,
    }));
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    fileInput.current.click();
  };
  return (
    <div className={`fileUpload ${className}`}>
      <input name={name} type="file" onChange={handleImageChange} ref={fileInput} className={"!hidden"} disabled={disabled} />
      <div className="flex justify-between mb-2 items-center">
        <div className="text-sm font-semibold flex gap-x-1">
          {required && <span className="text-red-600">*</span>}
          {title}
          {!required && <span className="text-grey-400 font-light text-xs pt-0.5">({generalTexts?.optional})</span>}
        </div>
        {(fileState === null && !previewImageUrl) || disabled ? (
          <span className=" text-2xs cursor-pointer text-grey-400 flex gap-x-1 items-center" onClick={() => handleClick()}>
            <PlusIcon width={12} height={12} stroke="#FF6136" />
            اضافه کردن تصویر
          </span>
        ) : (
          <span className=" text-2xs cursor-pointer text-grey-400 flex gap-x-1 items-center" onClick={() => handleClick()}>
            <EditIcon width={12} height={12} stroke="#FF6136" />
            ویرایش تصویر
          </span>
        )}
      </div>
      <div
        className={`mx-auto ${
          !imageUrlState ? `${!validationError ? "border-grey-200 text-grey-300" : "border-red-600 text-red-300"} border-2 h-44 border-dashed items-center justify-center flex text-sm font-semibold ` : ""
        } overflow-hidden rounded-xl ${inputWrapperClassName ?? ""}`}
      >
        {imageUrlState ? <img src={imageUrlState as string} alt="..." className={inputClassName ?? ""} /> : validationError ? "اپلود عکس اجباری می باشد" : title}
      </div>
    </div>
  );
}

export default ImageUpload;
